const initialState = {
  products: [],
  count: 0,
  sort: [
    {
      name: "Популярности",
      type: "VIEWS",
    },
    {
      name: "Цене",
      type: "PRICE",
    },
    {
      name: "Новизне",
      type: "ID",
    },
    {
      name: "Скидке",
      type: "DISCOUNT",
    },
  ],
  size: [24, 36, 48],
  meta: {},
  params: {
    pageSize: 25,
    pageNum: 1,
    sortBy: "PRICE",
    sortOrder: "asc",
    sectionId: 0,
  },
  stubData: null,
  /** Минимальная цена по всей выборке фильтра — для подстановки #MIN_PRICE# в мете */
  minPrice: 0,
  /** id записи seo-meta-catalog, из которой собрана новая мета (null — не найдена) */
  metaRecordId: null,
  /** Сортировка, по которой отдана выдача (pagesSrrLogic/catalog/section/catalogSort.ts) */
  catalogSort: null,
  qestionsAndReviewsCount: {},
};

export const sectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_STUB_DATA":
      return { ...state, stubData: action.payload };
    case "FETCH_SECTION":
      return { ...state, products: [...state.products, ...action.payload] };
    case "SET_COUNT":
      return { ...state, count: action.payload };
    case "SET_MIN_PRICE":
      return { ...state, minPrice: action.payload };
    case "SET_SECTION_ID":
      return {
        ...state,
        params: { ...state.params, sectionId: action.payload },
      };
    case "SET_PAGE_NUM":
      return { ...state, params: { ...state.params, pageNum: action.payload } };
    case "SET_PAGE_SIZE":
      return {
        ...state,
        params: { ...state.params, pageSize: action.payload },
      };
    case "SET_SORT_BY":
      return { ...state, params: { ...state.params, sortBy: action.payload } };
    case "SET_SORT_ORDER":
      return {
        ...state,
        params: { ...state.params, sortOrder: action.payload },
      };
    case "SET_META":
      return { ...state, meta: action.payload };
    case "SET_META_RECORD_ID":
      return { ...state, metaRecordId: action.payload };
    case "SET_CATALOG_SORT":
      return { ...state, catalogSort: action.payload };
    default:
      return state;
  }
};
